<template>
  <NavCo></NavCo>

  <div class="container-fluid bg-dark">

    <PortfolioIntro />

    <CV />

    <Eclipse />

    <AutoSolutions />

    <RickAndMorty />

    <PMS />

    <Instaman />

    <Jobs4all />

    <Indie />

    <Note11 />

    <Shopper />

    <APICentral />

    <Symposium />

    <RMvue />

  </div>

  <FooterCo></FooterCo>
</template>

<script>
import NavCo from '@/components/NavCo.vue'
import FooterCo from '@/components/FooterCo.vue';
import Shopper from '@/components/Shopper.vue';
import Indie from '@/components/Indie.vue';
import Eclipse from '@/components/Eclipse.vue';
import AutoSolutions from '@/components/AutoSolutions.vue';
import RickAndMorty from '@/components/RickAndMorty.vue';
import PMS from '@/components/PMS.vue';
import Instaman from '@/components/Instaman.vue';
import Jobs4all from '@/components/Jobs4all.vue';
import Note11 from '@/components/Note11.vue';
import APICentral from '@/components/APICentral.vue';
import Symposium from '@/components/Symposium.vue';
import RMvue from '@/components/RMvue.vue';
import CV from '@/components/CV.vue';
import PortfolioIntro from '@/components/PortfolioIntro.vue';

export default {
  components: { NavCo, FooterCo, Shopper, 
    Indie, Eclipse, AutoSolutions, RickAndMorty,
    PMS, Instaman, Jobs4all, Note11, APICentral,
    Symposium, RMvue, CV, PortfolioIntro
  },
}
</script>